import {
    DRAWER_PLACEMENTS,
    MATCHING_SCORE_TYPE,
    NOTIFICATION_TYPES,
    OPERATIONS,
    SECTIONS
} from "../../../../config/constants";
import PageHead from "../../../layout/PageHead";
import {
    Breadcrumb,
    Button,
    Checkbox,
    Divider,
    Drawer, Dropdown,
    Empty,
    Form,
    Input,
    Menu, Modal,
    Popconfirm,
    Select,
    Space,
    Spin,
    Tooltip,
} from "antd";
import {useNavigate, useSearchParams} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import TablesService from "../../../../services/tables/TablesService";
import GroupCodesService from "../../../../services/groupcodes/GroupCodesService";
import {
    ClusterOutlined,
    EditOutlined,
    CloseOutlined,
    CheckOutlined,
    QuestionCircleOutlined,
    PlusOutlined,
    DeleteOutlined,
    SyncOutlined,
    DownOutlined,
    FolderViewOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import {ROUTES} from "../../../../config/consts/routes";
import styles from "./Clustering.module.css";
import "./Clustering.css";
import {GetTablesRequest} from "../../../../models/tables/GetTablesRequest";
import ClusteringService from "../../../../services/clustering/ClusteringService";
import Datatable from "../../../shared/components/Datatable";
import TableDrawer from "../../../shared/components/table-drawer/TableDrawer";
import TableExport from "../../../shared/components/table-export/TableExport";
import NotificationsUtil from "../../../shared/utils/NotificationsUtil";
import history from "../../../shared/utils/HistoryUtil";
import LabelUtil from "../../../shared/utils/LabelUtil";
import {useSelector} from "react-redux";
import { TableRequest } from "../../../../models/tables/TableRequest";
import { GetFieldsRequest } from "../../../../models/fields/GetFieldsRequest";
import { FieldRequest } from "../../../../models/fields/FieldRequest";
import { RuleDefinition } from "../../../../models/rules/RuleDefinition";
import BatchProcessingService from "../../../../services/batchprocessing/BatchProcessingService";
import {
    CLUSTERING_STEP_PARAMETERS,
    EXTRACTION_PROCEDURE_NAMES,
} from "../../../../config/consts/extraction";
import {setEntity, setGroupCode} from "../../../../redux/actions";
import { useDispatch } from "react-redux";
import { AxiosResponse } from "axios";
import { ColumnsType } from "antd/lib/table";
import DownloadFile from "../../../shared/utils/DownloadUtil";
import { Entity } from "../../../../models/entities/Entity";
import EnvironmentService from "../../../../services/environments/EnvironmentService";
import FieldMappingsService from "../../../../services/fieldmappings/FieldMappingsService";

const routes = [
    {
        path: ROUTES.general.main.name,
        breadcrumbName: SECTIONS.general.name,
    },
    {
        breadcrumbName: SECTIONS.operation.name,
    },
    {
        path: ROUTES.operation.clustering.route,
        breadcrumbName: ROUTES.operation.clustering.name,
    },
];

const Clustering = () => {
    enum RowAction {
        View = 1,
        Edit,
        Create,
    }

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { profile, userHasPermissions } = useSelector((state: any) => ({
        profile: state.profile,
        userHasPermissions: state.userHasPermissions,
    }));

    const { t, i18n } = useTranslation("translations");

    const [searchParams, setSearchParams] = useSearchParams();

    const rulesRef = useRef<any>();

    const [groupCodes, setGroupCodes] = useState<any>([]);
    const [entities, setEntities] = useState<any>([]);
    const [operations, setOperations] = useState<any>([]);
    const [selectedGroupCode, setSelectedGroupCode] = useState<any>();
    const [selectedEntity, setSelectedEntity] = useState<any>();
    const [selectedOperation, setSelectedOperation] = useState<any>();
    const [newClusteringRuleModalEnabled, setNewClusteringRuleModalEnabled] = useState(false);

    const [updateRuleAllowed, setUpdateRuleAllowed] = useState<boolean>(false);
    const [updateRuleLoading, setUpdateRuleLoading] = useState<boolean>(false);
    const [updateRuleDefinitionLoading, setUpdateRuleDefinitionLoading] = useState<boolean>(false);

    const [isRulesLoading, setIsRulesLoading] = useState(false);
    const [isRuleDefinitionsLoading, setIsRuleDefinitionsLoading] = useState(false);

    const [drawerAction, setDrawerAction] = useState<RowAction>();
    const [drawerTitle, setDrawerTitle] = useState<any>("");
    const [openDrawer, setOpenDrawer] = useState(false);
    const [editedRow, setEditedRow] = useState<any>();
    const [originalEditedRow, setOriginalEditedRow] = useState<any>();

    const [selectedTable, setSelectedTable] = useState<any>(null);
    const [tables, setTables] = useState<any>([]);

    const [selectedTargetTable, setSelectedTargetTable] = useState<any>(null);
    const [targetTables, setTargetTables] = useState<any>([]);

    const [selectedOverruleTable, setSelectedOverruleTable] = useState<TableRequest>(null);
    const [overruleTables, setOverruleTables] = useState<TableRequest[]>([]);

    const [rules, setRules] = useState<any>([]);
    const [selectedRule, setSelectedRule] = useState<any>(null);

    const [ruleDefinitions, setRuleDefinitions] = useState<any>([]);
    const [selectedRuleDefinition, setSelectedRuleDefinition] = useState<any>(null);

    const [stepTemplates, setStepTemplates] = useState<any>([]);

    const [transforms, setTransforms] = useState<any>([]);
    
    const [fields, setFields] = useState<any>([]);
    const [targetFields, setTargetFields] = useState<any>([]);
    const [overruleFields, setOverruleFields] = useState<FieldRequest[]>([]);

    const [isDirty, setIsDirty] = useState<any>(false);
    const [popConfirmOpen, setPopConfirmOpen] = useState<boolean>(false);
    const [loadingButton, setLoadingButton] = useState(false);

    const [upsertButtonEnabled, setUpsertButtonEnabled] = useState(false);

    const [isRedirectModalOpen, setIsRedirectModalOpen] = useState(false);
    const [isProcessClusteringDrawerOpen, setIsProcessClusteringDrawerOpen] = useState(false);
    const [selectedProcessClusteringGroupCode, setSelectedProcessClusteringGroupCode] = useState<string>();

    const [openResultsDrawer, setOpenResultsDrawer] = useState<boolean>(false);
    const [isResultsTableDataLoading, setIsResultsTableDataLoading] = useState<boolean>(false);
    const [resultsTableData, setResultsTableData] = useState<any>([]); //Of type any because the returned type depends on the backend.
    const [resultsColumns, setResultsColumns] = useState<ColumnsType>([]);
    const [resultsTablePageIndex, setResultsTablePageIndex] = useState<number>(1);
    const [resultsTablePageSize, setResultsTablePageSize] = useState<number>(20);
    const [showExportDrawer, setShowExportDrawer] = useState<boolean>(false);
    const [isDownloadingExportData, setIsDownloadingExportData] = useState<boolean>(false);
    const [environments, setEnvironments] = useState<any[]>([]);
    const [selectedEnvironment, setSelectedEnvironment] = useState<string | null>(null);

    const [selectedFieldId, setSelectedFieldId] = useState<number>();

    const { Option } = Select;

    useEffect(() => {
        document.title = ROUTES.operation.clustering.name;
    }, []);

    useEffect(() => {
        EnvironmentService.getAll().then((response: any) => {
            const data = response.data;
            setEnvironments([{ id: -1, name: "Use default"}, ...data]);
        });
    }, []);

    useEffect(() => {
        GroupCodesService.getAll().then((response: any) => {
            const data = response.data;
            setGroupCodes(data);
        });
        TablesService.getAllEntities().then((response: any) => {
            const data = response.data;
            setEntities(data);
        });
        TablesService.getAllOperations().then((response: any) => {
            const data = response.data;
            setOperations(data);
        });
    }, []);

    useEffect(() => {
        if (operations) {
            setSelectedOperation(OPERATIONS.LEGACY)
        }
    }, [operations]);

    useEffect(() => {
        const model = {
            entity: entities.find((x: any) => x.id === selectedEntity)?.name,
            groupcode: selectedGroupCode,
        };
        BatchProcessingService.getAllStepTemplates(model).then(
            (response: any) => {
                setStepTemplates(response.data);
            }
        );
    }, []);

    useEffect(() => {
        if (selectedRule?.environment !== 'Use default') {
            setUpdateRuleAllowed(true);
        } 
    }, [selectedEnvironment]);

    useEffect(() => {
        setSelectedRule(undefined);
        setSelectedRuleDefinition(undefined);

        if (selectedEntity) {
            let model: GetTablesRequest = {
                entityId: selectedEntity,
                operationId: -1,
                groupCode: "",
            };

            TablesService.getTables(model).then((response: any) => {
                let data = response.data;
                setTables(data.filter((x: any) => x.operationId !== OPERATIONS.LOADFILE && x.operationId !== OPERATIONS.IMPORT && x.operationId !== OPERATIONS.ENRICHMENT))
                setTargetTables(data);
                setOverruleTables(data);
            });
        }
    }, [selectedEntity, selectedOperation]);

    useEffect(() => {
        setIsRulesLoading(true);
        if (selectedEntity) {
            ClusteringService.getAllRules(selectedEntity).then((resp:any) => {
                setRules(resp.data.map(x => ({
                    ...x,
                    environment: x.environment === null || x.environment == "" ? "Use default" : x.environment,
                })));
                setIsRulesLoading(false);
            })
        }
    }, [selectedEntity]);

    useEffect(() => {
        if (selectedTable) {
            const model: GetFieldsRequest = {
                tableId: selectedTable?.id,
            };

            TablesService.getFields(model).then((response: any) => {
                if (response.data && response.data.length > 0) {
                    const responseData = response.data;
                    setFields(responseData);
                }
            });
        }

    }, [selectedTable]);

    useEffect(() => {
        ClusteringService.getTransforms().then((response: any) => {
            if (response.data && response.data.length > 0) {
                const responseData = response.data;
                setTransforms(responseData);
            }
        });
    }, [selectedTable]);

    useEffect(() => {
        if (selectedTargetTable) {
            const model: GetFieldsRequest = {
                tableId: selectedTargetTable?.id,
            };

            TablesService.getFields(model).then((response: any) => {
                if (response.data && response.data.length > 0) {
                    const responseData = response.data;
                    setTargetFields(responseData);
                }
            });
        }

    }, [selectedTargetTable]);

    useEffect(() => {
        if (selectedOverruleTable) {
            const model: GetFieldsRequest = {
                tableId: selectedOverruleTable?.id,
            };

            TablesService.getFields(model).then((response: AxiosResponse) => {
                if (response.data && response.data.length > 0) {
                    const responseData = response.data;
                    setOverruleFields(responseData);
                }
            });
        }

    }, [selectedOverruleTable]);

    useEffect(() => {
        if (!isDirty) return;

        const unblock = history.block((tx: any) => {
            if (
                window.confirm(
                    "Are you sure you want leave the page without saving? Current changes will be lost."
                )
            ) {
                unblock();
                tx.retry();
            }
        });

        return () => {
            unblock();
        };
    }, [isDirty]);

    useEffect(() => {
        if (editedRow && originalEditedRow) {
            if (!upsertButtonEnabled) {
                setIsDirty(false);
            } else {
                setIsDirty(true);
            }
        } else {
            setIsDirty(false);
        }
    }, [upsertButtonEnabled]);

    useEffect(() => {
        if (selectedRule) {
            if (updateRuleAllowed) {
                setIsDirty(true);
                return;
            }
        }
        setIsDirty(false);
    }, [selectedRule, selectedRuleDefinition, updateRuleAllowed]);

    useEffect(() => {
        if (!userHasPermissions.write) {
            setUpdateRuleAllowed(false);
            return;
        }

        if (selectedRule && rules) {
            const current = JSON.stringify(selectedRule);
            const def = JSON.stringify(
                rules.find((x: any) => x.id === selectedRule.id)
            );

            if (!selectedRule?.name || selectedRule?.name?.length === 0) {
                setUpdateRuleAllowed(false);
                return;
            }

            if (!def) {
                setUpdateRuleAllowed(true);
                return;
            }

            if (current !== def) {
                setUpdateRuleAllowed(true);
            } else {
                setUpdateRuleAllowed(false);
            }
        } else {
            setUpdateRuleAllowed(false);
        }
    }, [selectedRule, rules]);

    useEffect(() => {
        if (!userHasPermissions.write) {
            setUpsertButtonEnabled(false);
            return;
        }

        if (selectedRuleDefinition && ruleDefinitions) {
            const current = JSON.stringify(selectedRuleDefinition);
            const def = JSON.stringify(
                ruleDefinitions.find((x: any) => x.id === selectedRuleDefinition.id)
            );

            if (!def) {
                setUpsertButtonEnabled(true);
                return;
            }

            if (current !== def) {
                setUpsertButtonEnabled(true);
            } else {
                setUpsertButtonEnabled(false);
            }
        } else {
            setUpsertButtonEnabled(false);
        }
    }, [selectedRuleDefinition, ruleDefinitions]);

    //Because the columns received from the backend are dynamic, we need to map them ourselves.
    useEffect(() => {
        if(resultsTableData?.length > 0) {
            const columns = Object.keys(resultsTableData[0]);
            setResultsColumns(columns.map(item => ({
                    title: item,
                    dataIndex: item,
                    key: item,
                    width: 200,
                    filters: [],
                    filterMode: "tree",
                    filterSearch: true,
                    ellipsis: true
                })
            ));
        }
    }, [resultsTableData])

    useEffect(() => {
        if (selectedRuleDefinition && (!selectedRuleDefinition.fieldMappings || selectedRuleDefinition.fieldMappings.length === 0)) {
            setSelectedRuleDefinition({
                ...selectedRuleDefinition,
                fieldMappings: [{ valueFrom: "", valueTo: "" }]
            });
        }
    }, [selectedRuleDefinition]);

    const showDrawer = (action: RowAction, recordId: any = null, name: string = "") => {
        setDrawerAction(action);
        switch (action) {
            case RowAction.View:
                setDrawerTitle(
                    t(
                        "Page.Operation.Clustering.RowDetails",
                        {
                            lngs: i18n.languages,
                            defaultValue: "Row details",
                        }
                    )!
                );
                break;
            case RowAction.Create:
                setDrawerTitle(
                    t(
                        "Page.Operation.Clustering.NewRuleDefinition",
                        {
                            lngs: i18n.languages,
                            defaultValue: "New rule definition",
                        }
                    )!
                );
                break;
            case RowAction.Edit:
                setDrawerTitle(
                    <>
            <span>
              {t(
                  "Page.Operation.Clustering.EditRule",
                  {
                      lngs: i18n.languages,
                      defaultValue: "Edit rule definition",
                  }
              )} {name ? " - " + name : ""}
            </span>
                        <span style={{ marginLeft: "10px", color: "grey", fontSize: 12 }}>
              {recordId}
            </span>
                    </>
                );
                break;
            default:
                break;
        }
        setOpenDrawer(true);
    };

    const dropdownMenu = (
        <Menu
            className="twoFoldMenu"
            style={{ padding: "10px" }}
            selectable
            onClick={null}
            items={[
                {
                    label: t("Page.Operation.Clustering.Labels.LatestClusteringResults", {
                        lngs: i18n.languages,
                        defaultValue: "Show latest clustering results",
                    }),
                    key: "1",
                    icon: <FolderViewOutlined />,
                    disabled: !selectedGroupCode || !selectedEntity,
                    onClick: () => handleResultsButtonClick()
                },
            ]}
        />
    );

    const clusteringActionButton = (
        <Dropdown.Button
            type="primary"
            onClick={() => handleProcessClusteringButtonClick()}
            overlay={dropdownMenu}
            style={{ borderColor: "var(--white)" }}
            placement="bottomRight"
            trigger={["click"]}
            icon={<DownOutlined />}
        >
            <ClusterOutlined />
            {
                t("Page.Operation.Clustering.Labels.Process", {
                        lngs: i18n.languages,
                        defaultValue: "PROCESS",
                    }
                )}
        </Dropdown.Button>
    );

    const handleProcessClusteringButtonClick = () => {
        setIsProcessClusteringDrawerOpen(true);
    }

    const handleResultsButtonClick = () => {
        const selectedEntityName = entities.find((x: Entity) => x.id === selectedEntity).name;
        if(!selectedGroupCode || !selectedEntityName) {
            return;
        }

        getResultsData(selectedGroupCode, selectedEntityName);

        setOpenResultsDrawer(true);
    }

    const getResultsData = (groupCode: string, entity: string) => {
        setIsResultsTableDataLoading(true);

        ClusteringService.getClusteringResults(groupCode, entity)
            .then(response => {
                setResultsTableData(response.data);
            })
            .catch(error => {
                setResultsTableData([]);
                NotificationsUtil.openNotificationDialog({
                    message: error.response.data,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
            })
            .finally(() => {
                setIsResultsTableDataLoading(false);
            });
    }

    const downloadClusteringTableData = (groupCode: string, rowCount: number) => {
        const selectedEntityName = entities.find((x: Entity) => x.id === selectedEntity).name;
        if(!groupCode || !selectedEntityName) {
            return;
        }

        setIsDownloadingExportData(true);

        ClusteringService.downloadClusteringResults(groupCode, selectedEntityName, undefined, rowCount)
            .then((response) => {
                DownloadFile(response.data, `ClusteringResults-${selectedEntityName}-${groupCode}.xlsx`);
                setShowExportDrawer(false);
            })
            .catch((error) => {
                NotificationsUtil.openNotificationDialog({
                    message: t(
                        "General.Notifications.Labels.DownloadFailed",
                        {
                            lngs: i18n.languages,
                            defaultValue: "Failed to download.",
                        }
                    ),
                    description: error.response.data,
                    placement: "bottomRight",
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: false,
                });
            })
            .finally(() => setIsDownloadingExportData(false));
    }

    const handleGroupCodeChange = (groupCode: string) => {
        setSelectedProcessClusteringGroupCode(groupCode);
    }

    const onSelectedRuleDefinitionTableChange = (value: any) => {
        setSelectedRuleDefinition({...selectedRuleDefinition, tableId: value})
        setSelectedTable(tables.find((x: any) => x.id === value));
    };

    const onSelectedRuleDefinitionFieldChange = (value: any) => {
        console.log(transforms.filter((x:any) => x.fieldId == value))
        setSelectedRuleDefinition({...selectedRuleDefinition, fieldId: value, fieldMappings: transforms.filter((x:any) => x.fieldId == value)})
    }

    const onSelectedRuleDefinitionTargetTableChange = (value: any) => {
        setSelectedRuleDefinition({...selectedRuleDefinition, targetTableId: value})
        setSelectedTargetTable(targetTables.find((x: any) => x.id === value));
    }

    const onSelectedRuleDefinitionOverruleTableChange = (value: number) => {
        setSelectedRuleDefinition({...selectedRuleDefinition, overruleTableId: value})
        setSelectedOverruleTable(overruleTables.find((x: TableRequest) => x.id === value));
    }

    const onSelectedRuleDefinitionTargetFieldChange = (value: any) => {
        setSelectedRuleDefinition({...selectedRuleDefinition, targetFieldId: value})
    }

    const onSelectedRuleDefinitionOverruleFieldChange = (value: number) => {
        setSelectedRuleDefinition({...selectedRuleDefinition, overruleFieldId: value})
    }

    const onSelectedRuleDefinitionMatchingChange = (value: any) => {
        setSelectedRuleDefinition({...selectedRuleDefinition, matching: value})
    }

    const onSelectedRuleDefinitionMatchingScoreChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
        const { value: inputValue } = event.target;
        setSelectedRuleDefinition({...selectedRuleDefinition, matchingScore: inputValue});
    }
    
    const onSelectedRuleDefinitionBlankAsNullChange = (value: any) => {
        setSelectedRuleDefinition({...selectedRuleDefinition, blankAsNull: value});
    }

    const handleRuleChange = (value: string) => {
        const rule = rules.find((x: any) => x.id === value)
        setSelectedRule(rule);

        setIsRuleDefinitionsLoading(true);
        if (rule && rule?.id !== -1) {
            ClusteringService.getAllRuleDefinitions(rule.id).then((resp: any) => {
                setRuleDefinitions(resp.data.map((x: any) => ({
                    ...x,
                    matchingLabel: x.matching === MATCHING_SCORE_TYPE.EXACT ? "Exact" : "Fuzzy",
                })))
                setIsRuleDefinitionsLoading(false);
            })
        }
    };

    const handleRulesMenuClick = (e: any) => {
        if (selectedRule && selectedRule.id.toString() === e.key) {
            return;
        }

        const rule = rules.find((x: any) => x.id.toString() === e.key);
        setSelectedRule(rule);

        setIsRuleDefinitionsLoading(true);
        if (rule && rule?.id !== -1) {
            ClusteringService.getAllRuleDefinitions(rule.id).then((resp: any) => {
                setRuleDefinitions(resp.data.map((x: any) => ({
                    ...x,
                    matchingLabel: x.matching === MATCHING_SCORE_TYPE.EXACT ? "Exact" : "Fuzzy",
                    matchingScore: x.matching === MATCHING_SCORE_TYPE.EXACT ? 100 : x.matchingScore,
                })))
                setIsRuleDefinitionsLoading(false);
            })
        }
    };

    const onClose = () => {
        setOpenDrawer(false);
        setEditedRow(null);
        setOriginalEditedRow(null);
        setSelectedRuleDefinition(undefined);
        setSelectedTable(undefined);
        setSelectedTargetTable(undefined);
        setSelectedOverruleTable(undefined);
        setSelectedFieldId(undefined);
    };

    const onEditRuleDefinition = (record: any) => {
        showDrawer(RowAction.Edit, record.id);
        setSelectedRuleDefinition({...record, fieldMappings: [...transforms.filter((x:any) => x.fieldId == record.fieldId), { valueFrom: "", valueTo: "" }]});
        setSelectedFieldId(record.fieldId);
        setSelectedTable(tables.find((x: any) => x.id === record.tableId));
        setSelectedTargetTable(targetTables.find((x: any) => x.id === record.targetTableId));
        setSelectedOverruleTable(overruleTables.find((x: TableRequest) => x.id === record.overruleTableId));
    };

    const onCopyRuleDefinition = (record: any) => {
        showDrawer(RowAction.Create);
        setSelectedRuleDefinition({...record, id: -1, fieldMappings: [...transforms.filter((x:any) => x.fieldId == record.fieldId), { valueFrom: "", valueTo: "" }]});
        setSelectedTable(tables.find((x: any) => x.id === record.tableId));
        setSelectedTargetTable(targetTables.find((x: any) => x.id === record.targetTableId));
        setSelectedOverruleTable(overruleTables.find((x: TableRequest) => x.id === record.overruleTableId));
    };

    const onDeleteRuleDefinition = (id: any, record: any) => {
        setIsRuleDefinitionsLoading(true);
        ClusteringService.deleteRuleDefinition(record.ruleId, record.fieldId)
            .then((response: any) => {
                NotificationsUtil.openNotificationDialog({
                    description: t(
                        "Page.Operation.Clustering.Notifications.RuleDefinition.DeleteSuccessDescription",
                        {
                            lngs: i18n.languages,
                            defaultValue: "Rule definition deleted successfully.",
                        }
                    )!,
                    type: NOTIFICATION_TYPES.SUCCESS,
                    logError: false,
                });
                ClusteringService.getAllRuleDefinitions(selectedRule.id).then((resp: any) => {
                    setRuleDefinitions(resp.data.map((x: any) => ({
                        ...x,
                        matchingLabel: x.matching === MATCHING_SCORE_TYPE.EXACT ? "Exact" : "Fuzzy",
                    })))
                    setIsRuleDefinitionsLoading(false);
                })
            })
            .catch((error: any) => {
                NotificationsUtil.openNotificationDialog({
                    description: error.response.data,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
            });
    };

    const onDoubleClickRow = (record: any) => {
        showDrawer(RowAction.View);
        setEditedRow(record);
    };

    const onDeleteRule = () => {
        if(!selectedRule?.id) {
            return;
        }

        ClusteringService.deleteRule(selectedRule.id)
            .then(() => {
                setSelectedRule(undefined);
                setIsRulesLoading(true);
                ClusteringService.getAllRules(selectedEntity).then((response:AxiosResponse) => {
                    setRules(response.data.map(x => ({
                        ...x,
                        environment: x.environment === null || x.environment == "" ? "Use default" : x.environment,
                    })));
                })
                    .finally(() => setIsRulesLoading(false));

                NotificationsUtil.openNotificationDialog({
                    description: t(
                        "Page.Operation.Clustering.Notifications.Rule.DeleteSuccessDescription",
                        {
                            lngs: i18n.languages,
                            defaultValue: "Clustering rule deleted successfully.",
                        }
                    )!,
                    type: NOTIFICATION_TYPES.SUCCESS,
                    logError: false,
                });
            })
            .catch((error: any) => {
                NotificationsUtil.openNotificationDialog({
                    description: error.response.data,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
            });
    };

    const onSelectedRuleNameChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
        const { value: inputValue } = event.target;
        setSelectedRule({...selectedRule, name: inputValue});
    }

    const onSelectedRuleMatchingScoreChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
        const { value: inputValue } = event.target;
        setSelectedRule({...selectedRule, matchingScore: inputValue});
    }

    const onSelectedRuleActiveChange = (value: boolean) => {
        setSelectedRule({...selectedRule, isActive: value});
    }
    
    const onSelectedEnvironmentChange = (value: string) => {
        setSelectedRule({...selectedRule, environment: value});
    }

    const addNewFieldMapping = () => {
        const updatedFieldMappings = [...(selectedRuleDefinition.fieldMappings || [])];

        updatedFieldMappings.push({
            valueFrom: "",
            valueTo: "",
        });
        
        setSelectedRuleDefinition({
            ...selectedRuleDefinition,
            fieldMappings: updatedFieldMappings
        });
    }
    
    const onSaveRule = () => {
        setUpdateRuleLoading(true);

        const ruleToSave = {
            ...selectedRule,
            environment: selectedRule.environment === "Use default" ? null : selectedRule.environment,
        };
        if (selectedRule?.id === -1) {
            ClusteringService.createRule(ruleToSave)
                .then((resp: any) => {
                    setSelectedRule(undefined);
                    setIsRulesLoading(true);
                    ClusteringService.getAllRules(selectedEntity).then((resp: any) => {
                        setRules(resp.data.map(x => ({
                            ...x,
                            environment: x.environment === null || x.environment == "" ? "Use default" : x.environment,
                        })));
                        setIsRulesLoading(false);
                    });
                    NotificationsUtil.openNotificationDialog({
                        description: t(
                            "Page.Operation.Clustering.Notifications.CreateRuleSuccessDescription",
                            {
                                lngs: i18n.languages,
                                defaultValue: "Rule has been successfully created.",
                            }
                        )!,
                        type: NOTIFICATION_TYPES.SUCCESS,
                        logError: false,
                    });
                    setUpdateRuleAllowed(false);
                    setUpdateRuleLoading(false);
                })
                .catch((error: any) => {
                    NotificationsUtil.openNotificationDialog({
                        description: error.response.data,
                        type: NOTIFICATION_TYPES.ERROR,
                        logError: true,
                    });
                    setUpdateRuleLoading(false);
                });
        } else {
            ClusteringService.updateRule(ruleToSave)
                .then((resp: any) => {
                    setIsRulesLoading(true);
                    ClusteringService.getAllRules(selectedEntity).then((resp: any) => {
                        setRules(resp.data.map(x => ({
                            ...x,
                            environment: x.environment === null || x.environment == "" ? "Use default" : x.environment,
                        })));
                        setIsRulesLoading(false);
                    });
                    NotificationsUtil.openNotificationDialog({
                        description: t(
                            "Page.Operation.Clustering.Notifications.UpdateRuleSuccessDescription",
                            {
                                lngs: i18n.languages,
                                defaultValue: "Rule has been successfully updated.",
                            }
                        )!,
                        type: NOTIFICATION_TYPES.SUCCESS,
                        logError: false,
                    });
                    setUpdateRuleAllowed(false);
                    setUpdateRuleLoading(false);
                })
                .catch((error: any) => {
                    NotificationsUtil.openNotificationDialog({
                        description: error.response.data,
                        type: NOTIFICATION_TYPES.ERROR,
                        logError: true,
                    });
                    setUpdateRuleLoading(false);
                });
        }
    };

    const onSaveRuleDefinition = () => {
        setUpdateRuleDefinitionLoading(true);

        console.log(selectedRuleDefinition.fieldMappings);
        const fieldMappings = selectedRuleDefinition.fieldMappings?.filter((x:any) => x.valueFrom).map((mapping) => ({
            id: mapping.id,
            valueFrom: mapping.valueFrom || "",
            valueTo: mapping.valueTo || "",
            shouldDelete: mapping.shouldDelete ?? false
        })) || [];

        const ruleDefinitionToSave = {
            ...selectedRuleDefinition,
            fieldMappings: fieldMappings
        };

        if (ruleDefinitionToSave.id === -1) {
            ClusteringService.createRuleDefinition(ruleDefinitionToSave)
                .then((resp: any) => {
                    onClose();
                    setIsRuleDefinitionsLoading(true);
                    ClusteringService.getAllRuleDefinitions(selectedRule?.id).then((def: any) => {
                        setRuleDefinitions(def.data.map((x: any) => ({
                            ...x,
                            matchingLabel: x.matching === MATCHING_SCORE_TYPE.EXACT ? "Exact" : "Fuzzy",
                        })));
                        setIsRuleDefinitionsLoading(false);
                    });
                    NotificationsUtil.openNotificationDialog({
                        description: t(
                            "Page.Operation.Clustering.Notifications.CreateRuleDefinitionSuccessDescription",
                            {
                                lngs: i18n.languages,
                                defaultValue: "Rule definition has been successfully created.",
                            }
                        )!,
                        type: NOTIFICATION_TYPES.SUCCESS,
                        logError: false,
                    });
                    setUpdateRuleDefinitionLoading(false);
                })
                .catch((error: any) => {
                    NotificationsUtil.openNotificationDialog({
                        description: error.response.data,
                        type: NOTIFICATION_TYPES.ERROR,
                        logError: true,
                    });
                    setUpdateRuleDefinitionLoading(false);
                });
        } else {
            ClusteringService.updateRuleDefinition(selectedFieldId, ruleDefinitionToSave)
                .then((resp: any) => {
                    onClose();
                    setIsRuleDefinitionsLoading(true);
                    ClusteringService.getAllRuleDefinitions(selectedRule?.id).then((def: any) => {
                        setRuleDefinitions(def.data.map((x: any) => ({
                            ...x,
                            matchingLabel: x.matching === MATCHING_SCORE_TYPE.EXACT ? "Exact" : "Fuzzy",
                        })));
                        setIsRuleDefinitionsLoading(false);
                    });
                    NotificationsUtil.openNotificationDialog({
                        description: t(
                            "Page.Operation.Clustering.Notifications.UpdateRuleDefinitionSuccessDescription",
                            {
                                lngs: i18n.languages,
                                defaultValue: "Rule definition has been successfully updated.",
                            }
                        )!,
                        type: NOTIFICATION_TYPES.SUCCESS,
                        logError: false,
                    });
                    setUpdateRuleDefinitionLoading(false);
                })
                .catch((error: any) => {
                    NotificationsUtil.openNotificationDialog({
                        description: error.response.data,
                        type: NOTIFICATION_TYPES.ERROR,
                        logError: true,
                    });
                    setUpdateRuleDefinitionLoading(false);
                });
        }
    }

    const onNewRule = () => {
        setSelectedRule({
            id: -1,
            name: "",
            entityId: selectedEntity,
            isActive: true
        })
    }

    const onResetRule = () => {
        const defaultRule = rules.find((x: any) => x.id === selectedRule?.id);
        if (defaultRule) {
            setSelectedRule(defaultRule);
        } else {
            onNewRule();
        }
    }

    const onNewRuleDefinition = () => {
        showDrawer(RowAction.Create);
        setSelectedRuleDefinition({
            id: -1,
            ruleId: selectedRule?.id,
            tableId: undefined,
            fieldId: undefined,
            targetTableId: undefined,
            targetFieldId: undefined,
            overruleTableId: undefined,
            overruleFieldId: undefined,
            matching: MATCHING_SCORE_TYPE.EXACT,
            matchingScore: undefined,
        })
    }

    const handleOpenPopConfirm = (newOpen: boolean) => {
        if (!newOpen) {
            setPopConfirmOpen(newOpen);
            return;
        }
        if (!isDirty) {
            onClose();
        } else {
            setPopConfirmOpen(newOpen);
        }
    }

    const createProcessCLusteringTask = () => {
        const step = getProcessClusteringStep();

        const task = {
            name: `PROCESS_CLUSTERING`,
            entity: entities.find((x: any) => x.id === selectedEntity).name,
            groupCode: selectedProcessClusteringGroupCode,
            stepTemplates: [step],
            executeImmediate: true,
        };

        BatchProcessingService.createTask(task).then((response: any) => {
            if (response.status === 200) {
                NotificationsUtil.openNotificationDialog({
                    message: "Task created",
                    type: NOTIFICATION_TYPES.SUCCESS,
                    logError: false,
                });
                setIsRedirectModalOpen(true);
            } else {
                NotificationsUtil.openNotificationDialog({
                    message: "Failed",
                    description: response.statusText,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
            }
        });
    }

    const getProcessClusteringStep = () => {
        const extractionStepTemplate = stepTemplates.find(t => t.procedure.label === EXTRACTION_PROCEDURE_NAMES.PROCESS_CLUSTERING);

        const step = {
            procedure: {
                id: extractionStepTemplate.procedure.id,
                label: extractionStepTemplate.procedure.label
            },
            parameters: [
                ...extractionStepTemplate.parameters.map((p) => {
                    let value;
                    switch (p.name) {
                        case CLUSTERING_STEP_PARAMETERS.GROUP_CODE:
                            value = selectedProcessClusteringGroupCode ?? "";
                            break;
                        default:
                            value = "";
                            break;
                    }
                    return {
                        id: p.id,
                        value: value
                    }
                })]
        };

        return step;
    };

    const handleRedirectModalOk = () => {
        setIsRedirectModalOpen(false);
        dispatch(setGroupCode(selectedProcessClusteringGroupCode));
        dispatch(setEntity(selectedEntity));
        navigate(
            `${ROUTES.batchProcessing.processOverview.route}`
        );
    };

    const handleRedirectModalCancel = () => {
        setIsRedirectModalOpen(false);
        navigate(0); // stay on & refresh current page
    };

    const handleDictionaryInputChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const deletedFieldMappings = selectedRuleDefinition?.fieldMappings?.filter((x:any) => x.shouldDelete) || [];
        const values = [...selectedRuleDefinition?.fieldMappings?.filter((x:any) => !x.shouldDelete) || []];
        values[index][event.target.name] = event.target.value;
        if (
            index === values.length - 1 &&
            (values[index].valueFrom !== "" || values[index].valueTo !== "")
        ) {
            values.push({ valueFrom: "", valueTo: "" });
        }

        setSelectedRuleDefinition({
            ...selectedRuleDefinition,
            fieldMappings: [...values, ...deletedFieldMappings],
        });
    };

    const onDeleteField = (index: number) => {
        if (index == selectedRuleDefinition.fieldMappings?.filter((x:any) => !x.shouldDelete).length - 1) {
            return;
        }
        
        let updatedFieldMappings = [...(selectedRuleDefinition.fieldMappings || [])];
        updatedFieldMappings[index] = {
            ...updatedFieldMappings[index],
            shouldDelete: true,
        };
        
        setSelectedRuleDefinition({
            ...selectedRuleDefinition,
            fieldMappings: updatedFieldMappings,
        });
    };

    const ruleDefinitionColumns = [
        {
            key: "tableName",
            title: t(
                "Page.Operation.Clustering.Table.Headers.Table",
                {
                    lngs: i18n.languages,
                    defaultValue: "Table",
                }
            ),
            editable: true,
            width: "150px",
            sorter: (a: any, b: any) => a.tableName ? a.tableName.localeCompare(b.tableName ?? "") : "".localeCompare(b.tableName ?? ""),
        },
        {
            key: "fieldName",
            title: t(
                "Page.Operation.Clustering.Table.Headers.Field",
                {
                    lngs: i18n.languages,
                    defaultValue: "Field",
                }
            ),
            editable: true,
            width: "150px",
            sorter: (a: any, b: any) => a.fieldName ? a.fieldName.localeCompare(b.fieldName ?? "") : "".localeCompare(b.fieldName ?? ""),
        },
        {
            key: "overruleTableName",
            title: t(
                "Page.Operation.Clustering.Table.Headers.OverruleTable",
                {
                    lngs: i18n.languages,
                    defaultValue: "Overrule Table",
                }
            ),
            editable: true,
            width: "150px",
            sorter: (a: RuleDefinition, b: RuleDefinition) => a.overruleTableName ? a.overruleTableName.localeCompare(b.overruleTableName ?? "") : "".localeCompare(b.overruleTableName ?? ""),
        },
        {
            key: "overruleFieldName",
            title: t(
                "Page.Operation.Clustering.Table.Headers.OverruleField",
                {
                    lngs: i18n.languages,
                    defaultValue: "Overrule Field",
                }
            ),
            editable: true,
            width: "150px",
            sorter: (a: RuleDefinition, b: RuleDefinition) => a.overruleFieldName ? a.fieldName.localeCompare(b.overruleFieldName ?? "") : "".localeCompare(b.overruleFieldName ?? ""),
        },
        {
            key: "targetTableName",
            title: t(
                "Page.Operation.Clustering.Table.Headers.TargetTable",
                {
                    lngs: i18n.languages,
                    defaultValue: "Target Table",
                }
            ),
            editable: true,
            width: "150px",
            sorter: (a: any, b: any) => a.tableName ? a.tableName.localeCompare(b.tableName ?? "") : "".localeCompare(b.tableName ?? ""),
        },
        {
            key: "targetFieldName",
            title: t(
                "Page.Operation.Clustering.Table.Headers.TargetField",
                {
                    lngs: i18n.languages,
                    defaultValue: "Target Field",
                }
            ),
            editable: true,
            width: "150px",
            sorter: (a: any, b: any) => a.targetFieldName ? a.targetFieldName.localeCompare(b.targetFieldName ?? "") : "".localeCompare(b.targetFieldName ?? ""),
        },
        {
            key: "matchingLabel",
            title: t(
                "Page.Operation.Clustering.Table.Headers.Matching",
                {
                    lngs: i18n.languages,
                    defaultValue: "Matching",
                }
            ),
            editable: true,
            width: "100px",
            sorter: (a: any, b: any) => a.matchingLabel ? a.matchingLabel.localeCompare(b.matchingLabel ?? "") : "".localeCompare(b.matchingLabel ?? ""),
        },
        {
            key: "matchingScore",
            title: t(
                "Page.Operation.Clustering.Table.Headers.MatchingScore",
                {
                    lngs: i18n.languages,
                    defaultValue: "Score",
                }
            ),
            editable: true,
            width: "100px",
            sorter: (a: any, b: any) => (a.matchingScore ?? 0) - (b.matchingScore ?? 0),
        },
    ];

    const fieldsColumns = [
        {           
            title: t("Page.Operation.Clustering.Table.Headers.ValueFrom", {
                lngs: i18n.languages,
                defaultValue: "Value From",
            }),
            key: "valueFrom",
            dataIndex: "valueFrom",
            editable: true,
            width: "150px",
            render: (text: string, record: any, index: any) => {
                return (<Input
                    value={record.valueFrom}
                    name="valueFrom"
                    placeholder={
                        t("General.Placeholders.EnterValue", {
                            lngs: i18n.languages,
                            defaultValue: "Enter value",
                        })!
                    }
                    onChange={(e) => handleDictionaryInputChange(index, e)}
                />);
            },
        },
        {
            title: t("Page.Operation.Clustering.Table.Headers.ValueTo", {
                lngs: i18n.languages,
                defaultValue: "Value To",
            }),
            key: "valueTo",
            dataIndex: "valueTo",
            editable: true,
            width: "150px",
            render: (text: string, record: any, index: any) => {
                return (<Input
                    value={record.valueTo}
                    name="valueTo"
                    placeholder={
                        t("General.Placeholders.EnterValue", {
                            lngs: i18n.languages,
                            defaultValue: "Enter value",
                        })!
                    }
                    onChange={(e) => handleDictionaryInputChange(index, e)}
                />);
            },
        },
        {
            key: "actions",
            fixed: "right",
            width: "50px",
            title: t("General.Labels.Actions", {
                lngs: i18n.languages,
                defaultValue: "Actions",
            }),
            render: (text: any, record: any, index :any) => (
                <Space>
                    <Button
                        size="small"
                        style={{padding: "0px 2px"}}
                        icon={
                            <DeleteOutlined
                                onClick={() => onDeleteField(index)}
                                className={
                                    userHasPermissions.delete
                                        ? styles.dangerColor
                                        : styles.disabledColor
                                }
                            />
                        }
                    />
                </Space>
            ),
        },
    ];



    const matchinTypes = [
        {
            id: MATCHING_SCORE_TYPE.EXACT,
            name: "Exact"
        },
        {
            id: MATCHING_SCORE_TYPE.FUZZY,
            name: "Fuzzy"
        },
    ]

    const scroll = { y: "calc(100vh - 380px)"  };

    return (
        <div>
            <PageHead
                title={ROUTES.operation.clustering.name}
                icon={<ClusterOutlined/>}
                routes={routes}
                groupCodes={groupCodes}
                entities={entities}
                operations={operations}
                selectedGroupCode={selectedGroupCode}
                selectedEntity={selectedEntity}
                selectedOperation={selectedOperation}
                setSelectedGroupCode={setSelectedGroupCode}
                setSelectedEntity={setSelectedEntity}
                setSelectedOperation={setSelectedOperation}
                setSelectGroupCodeDisabled={false}
                setSelectEntityDisabled={false}
                setSelectOperationDisabled={true}
                mainAction={clusteringActionButton}
                otherActions={[]}
                setActionsDisabled={false}
            />
            <div className="clustering-container">
                <div className="clustering-tab-container">
                    <div className="section-container">
                        <div>
                            <div className="section-header">
                                <Select
                                    ref={rulesRef}
                                    disabled={
                                        !selectedEntity
                                    }
                                    showSearch={true}
                                    showArrow={true}
                                    allowClear={true}
                                    value={selectedRule?.id == -1 ? undefined : selectedRule?.id}
                                    onChange={handleRuleChange}
                                    style={{ flex: 2, width: "85%" }}
                                    dropdownMatchSelectWidth={false}
                                    placeholder={t(
                                        "Page.Configuration.TableSetup.Tabs.TableSetup.Placeholders.SelectRule",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Rule",
                                        }
                                    )}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                                    }
                                    filterSort={(optionA, optionB) =>
                                        (optionA!.children as unknown as string)
                                            .toLowerCase()
                                            .localeCompare(
                                                (optionB!.children as unknown as string).toLowerCase()
                                            )
                                    }
                                >
                                    {rules.map((item: any) => {
                                        return <Option value={item.id}>{item.name}</Option>;
                                    })}
                                </Select>
                                <Button
                                    disabled={
                                        !selectedEntity
                                    }
                                    onClick={onNewRule}
                                    icon={<PlusOutlined />}
                                />
                            </div>
                            <Divider />
                            <div className="section-items">
                                {selectedEntity && !isRulesLoading ? (
                                    <Menu
                                        items={
                                            rules.map((item: any) => {
                                                return {
                                                    key: item.id,
                                                    label: item.name,
                                                };
                                            })
                                        }
                                        selectedKeys={[
                                            selectedRule?.id === "New rule"
                                                ? "New rule"
                                                : selectedRule?.id.toString(),
                                        ]}
                                        onClick={handleRulesMenuClick}
                                    />
                                ) : (
                                    <Empty
                                        description={
                                            (!selectedEntity) &&
                                            t("Page.Operation.Custering.Tutorial.GetStarted", {
                                                lngs: i18n.languages,
                                                defaultValue:
                                                    "Please select an Entity to get started",
                                            })
                                        }
                                    ></Empty>
                                )}
                                {selectedEntity && isRulesLoading && (
                                    <div className={styles.loadingContainer} style={{width: "100%", display: "flex", justifyContent: "center"}}>
                                        <Spin/>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="form-containers section-container-lg form-expanded">
                        {selectedRule && (
                            <div style={{maxHeight: "125px"}}>
                                <div className="title-actions">
                                    <Breadcrumb>
                                        {selectedRule?.id > -1 ? (
                                            <>
                                                <Breadcrumb.Item>
                                                    {selectedRule?.name?.length > 30
                                                        ? selectedRule?.name.slice(0, 30) + "..."
                                                        : selectedRule?.name}
                                                </Breadcrumb.Item>
                                                <Breadcrumb.Item>
                                                    {t(
                                                        "Page.Operation.Clustering.Labels.UpdateRule",
                                                        {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Update rule",
                                                        }
                                                    )}
                                                </Breadcrumb.Item>
                                            </>
                                        ) : (
                                            <Breadcrumb.Item>
                                                {t(
                                                    "Page.Operation.Clustering.Labels.NewRule",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "New rule",
                                                    }
                                                )}
                                            </Breadcrumb.Item>
                                        )}
                                    </Breadcrumb>

                                    <div className="action-buttons">
                                        <Tooltip
                                            title={
                                                !userHasPermissions.delete
                                                    ? "You don't have sufficient permissions to perform this action."
                                                    : ""
                                            }
                                        >
                                            <Popconfirm
                                                style={{width: "400px"}}
                                                placement="topRight"
                                                title={
                                                    <div
                                                        style={{
                                                            width: "400px",
                                                            wordBreak: "break-word",
                                                        }}
                                                    >
                                                        {t(
                                                            "Page.Operation.Clustering.Popups.DeleteRule",
                                                            {
                                                                lngs: i18n.languages,
                                                                defaultValue: "Are you really sure that you want to delete this rule?",
                                                            }
                                                        )}
                                                    </div>
                                                }
                                                icon={
                                                    <QuestionCircleOutlined
                                                        style={{color: "red"}}
                                                    />
                                                }
                                                onConfirm={onDeleteRule}
                                                okText={t("General.Actions.Yes", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Yes",
                                                })}
                                                cancelText={t("General.Actions.No", {
                                                    lngs: i18n.languages,
                                                    defaultValue: "No",
                                                })}
                                                // disabled={!userHasPermissions.delete}
                                            >
                                                <Button
                                                    size="small"
                                                    className={
                                                        userHasPermissions.delete
                                                            ? styles.dangerColor
                                                            : styles.disabledColor
                                                    }
                                                    style={{padding: "0px 2px"}}
                                                    icon={
                                                        <DeleteOutlined
                                                            className={
                                                                userHasPermissions.delete
                                                                    ? styles.dangerColor
                                                                    : styles.disabledColor
                                                            }
                                                        />
                                                    }
                                                    disabled={!userHasPermissions.delete}
                                                    hidden={selectedRule?.id <= 0}
                                                >
                                                    {t("General.Labels.Delete", {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Delete",
                                                    })}
                                                </Button>
                                            </Popconfirm>
                                        </Tooltip>
                                        <Button
                                            onClick={onResetRule}
                                            type="ghost"
                                            size="small"
                                            icon={<SyncOutlined/>}
                                        >
                                            {t("General.Labels.Reset", {
                                                lngs: i18n.languages,
                                                defaultValue: "Reset",
                                            })}
                                        </Button>
                                        <Tooltip
                                            title={
                                                !userHasPermissions.write
                                                    ? "You don't have sufficient permissions to perform this action."
                                                    : ""
                                            }
                                        >
                                            <Button
                                                className={
                                                    updateRuleAllowed ? "update-btn" : ""
                                                }
                                                disabled={!updateRuleAllowed}
                                                onClick={onSaveRule}
                                                size="small"
                                                icon={<CheckOutlined/>}
                                                loading={updateRuleLoading}
                                            >
                                                {selectedRule?.id > -1 ?
                                                    t("General.Labels.Update", {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Update",
                                                    }) :
                                                    t("General.Labels.Create", {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Create",
                                                    })
                                                }
                                            </Button>
                                        </Tooltip>
                                    </div>
                                </div>
                                <Divider/>
                                <div className="form-content">
                                    <div style={{width: "100%"}}>
                                        <Form layout="inline" size="small">
                                            <Form.Item
                                                label={t(
                                                    "Page.Operation.Clustering.Labels.Name",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Name:",
                                                    }
                                                )}
                                                tooltip={t(
                                                    "Page.Operation.Clustering.Tooltips.Name",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "",
                                                    }
                                                )}
                                            >
                                                <Input
                                                    placeholder={t("General.Placeholders.EnterValue", {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Enter value",
                                                    })}
                                                    allowClear
                                                    value={selectedRule?.name}
                                                    onChange={onSelectedRuleNameChange}
                                                ></Input>
                                            </Form.Item>
                                            <Form.Item
                                                label={t(
                                                    "Page.Operation.Clustering.Labels.MatchingScore",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Matching Score:",
                                                    }
                                                )}
                                                tooltip={t(
                                                    "Page.Operation.Clustering.Tooltips.MatchinScore",
                                                    {
                                                        lngs: i18n.languages,
                                                        defaultValue: "",
                                                    }
                                                )}
                                                
                                            >
                                                <Input
                                                    placeholder={t("General.Placeholders.EnterValue", {
                                                        lngs: i18n.languages,
                                                        defaultValue: "Enter value",
                                                    })}
                                                    allowClear
                                                    type={"number"}
                                                    value={selectedRule?.matchingScore}
                                                    onChange={onSelectedRuleMatchingScoreChange}
                                                ></Input>
                                            </Form.Item>
                                            <div className="checkboxes">
                                                <Form.Item
                                                    // className={styles.mb10px}
                                                    required
                                                    tooltip={t(
                                                        "Page.Operation.ValidationRules.Tabs.ValidationRules.Tooltips.IsActive",
                                                        {
                                                            lngs: i18n.languages,
                                                            defaultValue: "",
                                                        }
                                                    )}
                                                >
                                                    <Checkbox
                                                        checked={selectedRule?.isActive}
                                                        onClick={() => onSelectedRuleActiveChange(!selectedRule?.isActive)}
                                                    >
                                                        {t(
                                                            "Page.Operation.ValidationRules.Tabs.ValidationRules.Labels.IsActive",
                                                            {
                                                                lngs: i18n.languages,
                                                                defaultValue: "Is Active",
                                                            }
                                                        )}
                                                    </Checkbox>
                                                </Form.Item>
                                                <Form.Item
                                                    label={t(
                                                        "Page.Operation.Clustering.Labels.Environment",
                                                        {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Environment",
                                                        }
                                                    )}
                                                    tooltip={t(
                                                        "Page.Operation.Clustering.Tooltips.Environment",
                                                        {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Select the environment for this rule.",
                                                        }
                                                    )}
                                                    style={{ width: "100%" }}
                                                >
                                                    <Select
                                                        placeholder={t("Page.Operation.Clustering.Select.Environment", {
                                                            lngs: i18n.languages,
                                                            defaultValue: "Use default environment",
                                                        })}
                                                        allowClear
                                                        showSearch={true}
                                                        showArrow={true}
                                                        options={[
                                                            ...environments.map((env: any) => ({
                                                                label: env.name,
                                                                value: env.name,
                                                            })),
                                                        ]}
                                                        value={selectedRule?.environment}
                                                        onChange={onSelectedEnvironmentChange}
                                                    ></Select>
                                                </Form.Item>
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        )}
                        {selectedRule?.id > -1 && (
                            <div>
                                <div className="title-actions">
                                    <Breadcrumb>
                                        <Breadcrumb.Item>
                                            {t(
                                                "Page.Configuration.Clustering.Labels.RuleDefinitions",
                                                {
                                                    lngs: i18n.languages,
                                                    defaultValue: "Rule definitions",
                                                }
                                            )}
                                        </Breadcrumb.Item>
                                    </Breadcrumb>

                                    <div className="action-buttons">
                                        <Button
                                            className={
                                                "update-btn"
                                            }
                                            onClick={onNewRuleDefinition}
                                            size="small"
                                            icon={<PlusOutlined/>}
                                        >
                                            {t("Page.Operation.Clustering.Labels.NewRuleDefinition", {
                                                lngs: i18n.languages,
                                                defaultValue: "New definition",
                                            })}
                                        </Button>
                                    </div>
                                </div>
                                <Divider/>
                                <div className="form-content" style={{maxHeight: "60vh"}}>
                                    <Datatable
                                        scroll={scroll}
                                        tableColumns={ruleDefinitionColumns}
                                        data={ruleDefinitions}
                                        setData={setRuleDefinitions}
                                        isTableLoading={isRuleDefinitionsLoading}
                                        otherActions={[]}
                                        otherRowEnabled={false}
                                        editRowEnabled={true}
                                        copyRowEnabled={true}
                                        deleteRowEnabled={true}
                                        onEditFunc={onEditRuleDefinition}
                                        onCopyFunc={onCopyRuleDefinition}
                                        onDeleteFunc={onDeleteRuleDefinition}
                                        onDoubleClickRow={onDoubleClickRow}
                                        selectable={false}
                                        multiSelect={false}
                                        selectedRows={undefined}
                                        setSelectedRows={undefined}
                                        checkPermissions={true}
                                        paginationDisabled={true}
                                    ></Datatable>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Drawer
                width={"400px"}
                getContainer={false}
                style={{ position: "absolute" }}
                title={drawerTitle}
                placement={DRAWER_PLACEMENTS.BOTTOM}
                onClose={onClose}
                visible={openDrawer}
                closable={false}
                height={"450px"}
                extra={
                    <Space>
                        {RowAction?.View === drawerAction && (
                            <>
                                <Button
                                    onClick={() => showDrawer(RowAction.Edit)}
                                    icon={<EditOutlined />}
                                    className={"active-btn"}
                                    size="small"
                                >
                                    {t("General.Labels.Edit", {
                                        lngs: i18n.languages,
                                        defaultValue: "Edit",
                                    })}
                                </Button>
                                <Button
                                    type="ghost"
                                    onClick={onClose}
                                    icon={<CloseOutlined />}
                                    size="small"
                                />
                            </>
                        )}
                        {RowAction?.Create === drawerAction && (
                            <>
                                <Button
                                    // disabled={!valueInput}
                                    // className={!valueInput ? "" : "active-btn"}
                                    onClick={onSaveRuleDefinition}
                                    icon={<CheckOutlined />}
                                    size="small"
                                    loading={updateRuleLoading}
                                    disabled={!upsertButtonEnabled}
                                >
                                    {t("General.Labels.Save", {
                                        lngs: i18n.languages,
                                        defaultValue: "Save",
                                    })}
                                </Button>
                                <Popconfirm
                                    style={{ width: "400px" }}
                                    placement="topRight"
                                    title={
                                        <div
                                            style={{
                                                width: "400px",
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {t(
                                                "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.ConfirmClose",
                                                {
                                                    lngs: i18n.languages,
                                                    defaultValue:
                                                        "Are you really sure that you want to close this drawer? All changes made will be lost.",
                                                }
                                            )}
                                        </div>
                                    }
                                    icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                                    visible={popConfirmOpen}
                                    onVisibleChange={handleOpenPopConfirm}
                                    onConfirm={() => onClose()}
                                    // onCancel={() => cancel}
                                    okText={t("General.Actions.Yes", {
                                        lngs: i18n.languages,
                                        defaultValue: "Yes",
                                    })}
                                    cancelText={t("General.Actions.No", {
                                        lngs: i18n.languages,
                                        defaultValue: "No",
                                    })}
                                >
                                    <Button
                                        type="ghost"
                                        icon={<CloseOutlined />}
                                        size="small"
                                    />
                                </Popconfirm>
                            </>
                        )}
                        {RowAction?.Edit === drawerAction && (
                            <>
                                <Button
                                    // disabled={!updateRowAllowed}
                                    // className={!updateRowAllowed ? "" : "active-btn"}
                                    onClick={onSaveRuleDefinition}
                                    icon={<CheckOutlined />}
                                    size="small"
                                    loading={loadingButton}
                                    disabled={!upsertButtonEnabled}
                                >
                                    {t("General.Labels.Update", {
                                        lngs: i18n.languages,
                                        defaultValue: "Update",
                                    })}
                                </Button>
                                <Popconfirm
                                    style={{ width: "400px" }}
                                    placement="topRight"
                                    title={
                                        <div
                                            style={{
                                                width: "400px",
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {t(
                                                "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.ConfirmClose",
                                                {
                                                    lngs: i18n.languages,
                                                    defaultValue:
                                                        "Are you really sure that you want to close this drawer? All changes made will be lost.",
                                                }
                                            )}
                                        </div>
                                    }
                                    icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                                    visible={popConfirmOpen}
                                    onVisibleChange={handleOpenPopConfirm}
                                    onConfirm={() => onClose()}
                                    // onCancel={() => cancel}
                                    okText={t("General.Actions.Yes", {
                                        lngs: i18n.languages,
                                        defaultValue: "Yes",
                                    })}
                                    cancelText={t("General.Actions.No", {
                                        lngs: i18n.languages,
                                        defaultValue: "No",
                                    })}
                                >
                                    <Button
                                        type="ghost"
                                        icon={<CloseOutlined />}
                                        size="small"
                                    />
                                </Popconfirm>
                            </>
                        )}
                    </Space>
                }
            >
                <Form
                    disabled={RowAction.View === drawerAction ? true : false}
                    layout="vertical"
                >
                    <div className="clustering-drawer">
                        <div className="clustering-form-top" style={{display: "flex", flexDirection: "row", gap: "30px"}}>
                            <div style={{flexDirection: "column", display: "flex", width: "70%", gap: "10px"}}>
                                <Form.Item
                                    label={t(
                                        "Page.Operation.Clustering.Labels.Table",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Table:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Operation.Clustering.Tooltips.Table",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                    style={{width: "100%"}}
                                >
                                    <Select
                                        placeholder={t("Page.Operation.Clustering.Select.Table", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select Table",
                                        })}
                                        allowClear
                                        showSearch={true}
                                        showArrow={true}
                                        options={tables.map((x: any) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        value={selectedRuleDefinition?.tableId}
                                        filterOption={(input, option) =>
                                            (option!.label as unknown as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.value! < optionB.value! ? -1 : 1
                                        }
                                        onChange={onSelectedRuleDefinitionTableChange}
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={LabelUtil.ensureColonAtEnd(t(
                                        "Page.Operation.Clustering.Labels.OverruleTable",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Overrule Table",
                                        }
                                    ))}
                                    tooltip={t(
                                        "Page.Operation.Clustering.Tooltips.OverruleTable",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                    style={{width: "100%"}}
                                >
                                    <Select
                                        placeholder={t("Page.Operation.Clustering.Select.OverruleTable", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select Overrule Table",
                                        })}
                                        allowClear
                                        showSearch={true}
                                        showArrow={true}
                                        options={overruleTables.map((x: TableRequest) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        value={selectedRuleDefinition?.overruleTableId}
                                        filterOption={(input, option) =>
                                            (option!.label as unknown as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.value! < optionB.value! ? -1 : 1
                                        }
                                        onChange={onSelectedRuleDefinitionOverruleTableChange}
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Operation.Clustering.Labels.TargetTable",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Target Table:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Operation.Clustering.Tooltips.TargetTable",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                    style={{width: "100%"}}
                                >
                                    <Select
                                        placeholder={t("Page.Operation.Clustering.Select.TargetTable", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select Target Table",
                                        })}
                                        allowClear
                                        showSearch={true}
                                        showArrow={true}
                                        options={targetTables.map((x: any) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        value={selectedRuleDefinition?.targetTableId}
                                        filterOption={(input, option) =>
                                            (option!.label as unknown as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.value! < optionB.value! ? -1 : 1
                                        }
                                        onChange={onSelectedRuleDefinitionTargetTableChange}
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Operation.Clustering.Labels.Matching",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Matching:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Operation.Clustering.Tooltips.Matching",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                    style={{width: "100%"}}
                                >
                                    <Select
                                        placeholder={t("Page.Operation.Clustering.Select.Matching", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select Matching",
                                        })}
                                        allowClear
                                        showSearch={true}
                                        showArrow={true}
                                        options={matchinTypes.map((x: any) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        value={selectedRuleDefinition?.matching}
                                        filterOption={(input, option) =>
                                            (option!.label as unknown as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.value! < optionB.value! ? -1 : 1
                                        }
                                        onChange={onSelectedRuleDefinitionMatchingChange}
                                    ></Select>
                                </Form.Item>
                            </div>
                            <div style={{flexDirection: "column", display: "flex", width: "70%", gap: "10px"}}>
                                <Form.Item
                                    label={t(
                                        "Page.Operation.Clustering.Labels.Field",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Field:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Operation.Clustering.Tooltips.Field",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                    style={{width: "100%"}}
                                >
                                    <Select
                                        disabled={!selectedRuleDefinition?.tableId}
                                        placeholder={t("Page.Operation.Clustering.Select.Field", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select Field",
                                        })}
                                        allowClear
                                        showSearch={true}
                                        showArrow={true}
                                        options={fields.map((x: any) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        value={selectedRuleDefinition?.fieldId}
                                        filterOption={(input, option) =>
                                            (option!.label as unknown as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.value! < optionB.value! ? -1 : 1
                                        }
                                        onChange={onSelectedRuleDefinitionFieldChange}
                                    ></Select>
                                </Form.Item>
                               
                                <Form.Item
                                    label={LabelUtil.ensureColonAtEnd(t(
                                        "Page.Operation.Clustering.Labels.OverruleField",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Overrule Field",
                                        }
                                    ))}
                                    tooltip={t(
                                        "Page.Operation.Clustering.Tooltips.OverruleField",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                    style={{width: "100%"}}
                                >
                                    <Select
                                        disabled={!selectedRuleDefinition?.overruleTableId}
                                        placeholder={t("Page.Operation.Clustering.Select.OverruleField", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select Overrule Field",
                                        })}
                                        allowClear
                                        showSearch={true}
                                        showArrow={true}
                                        options={overruleFields.map((x: FieldRequest) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        value={selectedRuleDefinition?.overruleFieldId}
                                        filterOption={(input, option) =>
                                            (option!.label as unknown as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.value! < optionB.value! ? -1 : 1
                                        }
                                        onChange={onSelectedRuleDefinitionOverruleFieldChange}
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Operation.Clustering.Labels.TargetField",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Target Field:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Operation.Clustering.Tooltips.TargetField",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                    style={{width: "100%"}}
                                >
                                    <Select
                                        disabled={!selectedRuleDefinition?.targetTableId}
                                        placeholder={t("Page.Operation.Clustering.Select.TargetField", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select Target Field",
                                        })}
                                        allowClear
                                        showSearch={true}
                                        showArrow={true}
                                        options={targetFields.map((x: any) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        value={selectedRuleDefinition?.targetFieldId}
                                        filterOption={(input, option) =>
                                            (option!.label as unknown as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        filterSort={(optionA, optionB) =>
                                            optionA.value! < optionB.value! ? -1 : 1
                                        }
                                        onChange={onSelectedRuleDefinitionTargetFieldChange}
                                    ></Select>
                                </Form.Item>
                                <Form.Item
                                    label={t(
                                        "Page.Operation.Clustering.Labels.MatchingScore",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "Matching Score:",
                                        }
                                    )}
                                    tooltip={t(
                                        "Page.Operation.Clustering.Tooltips.MatchingScore",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "",
                                        }
                                    )}
                                    style={{width: "100%"}}
                                >
                                    <Input
                                        disabled={selectedRuleDefinition?.matching === MATCHING_SCORE_TYPE.EXACT}
                                        placeholder={t("General.Placeholders.EnterValue", {
                                            lngs: i18n.languages,
                                            defaultValue: "Enter value",
                                        })}
                                        allowClear
                                        type={"number"}
                                        value={selectedRuleDefinition?.matchingScore}
                                        onChange={onSelectedRuleDefinitionMatchingScoreChange}
                                    ></Input>
                                </Form.Item>
                            </div>  
                            <div style={{flexDirection: "column", display: "flex", width: "100%", overflow: "hidden"}}>
                                <div style={{display: "flex", alignItems: "center"}}>
                                    <Checkbox
                                        checked={selectedRuleDefinition?.blankAsNull}
                                        onChange={(e) => onSelectedRuleDefinitionBlankAsNullChange(e.target.checked)}
                                    >
                                        {t("Page.Operation.Clustering.Labels.ConsiderBlankValuesUnequal", {
                                            lngs: i18n.languages,
                                            defaultValue: "Consider Blank Values Unequal",
                                        })}
                                    </Checkbox>
                                    <Tooltip title={t(
                                        "Page.Operation.Clustering.Tooltips.ConsiderBlankValuesUnequal",
                                        {
                                            lngs: i18n.languages,
                                            defaultValue: "When enabled, blank values will not be considered equal for clustering purposes.",
                                        }
                                    )}>
                                        <QuestionCircleOutlined style={{marginLeft: "8px"}}/>
                                    </Tooltip>
                                </div>
                                <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
                                    <div style={{marginBottom: 8, marginTop: 8}}>
                                        <span style={{fontWeight: 500}}>
                                            {t("Page.Operation.Clustering.Labels.ReplaceValues", {
                                                lngs: i18n.languages,
                                                defaultValue: "Replace values:",
                                            })}
                                        </span>
                                        <Tooltip
                                            title={t("Page.Operation.Clustering.Tooltips.ReplaceValues", {
                                                lngs: i18n.languages,
                                                defaultValue: "Define value pairs to be replaced during clustering.",
                                            })}
                                        >
                                            <QuestionCircleOutlined style={{marginLeft: "8px"}}/>
                                        </Tooltip>

                                    </div>
                                    <Datatable
                                        tableColumns={fieldsColumns}
                                        data={selectedRuleDefinition?.fieldMappings?.filter((x: any) => !x.shouldDelete)}
                                        setData={setSelectedRuleDefinition}
                                        isTableLoading={false}
                                        scroll={scroll}
                                        selectable={false}
                                        multiSelect={false}
                                        showActionsColumn={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Drawer>
            <Drawer
                width={"400px"}
                getContainer={false}
                style={{ position: "absolute" }}
                title={"Process Clustering"}
                placement={DRAWER_PLACEMENTS.BOTTOM}
                onClose={() => setIsProcessClusteringDrawerOpen(false)}
                visible={isProcessClusteringDrawerOpen}
                closable={true}
                height={"300px"}
                extra={
                    <Space>
                        <Button
                            onClick={createProcessCLusteringTask}
                            icon={<ClusterOutlined />}
                            size="small"
                            loading={loadingButton}
                        >
                            {t(
                                "Page.Operation.Clustering.Labels.Process",
                                {
                                    lngs: i18n.languages,
                                    defaultValue: "Process",
                                }
                            )}
                        </Button>
                    </Space>
                }
            >
                <Form
                    layout="vertical"
                >
                    <div className="clustering-drawer">
                        <div className="clustering-form-top">
                            <Form.Item
                                label={t(
                                    "Page.Operation.Clustering.Labels.GroupCode",
                                    {
                                        lngs: i18n.languages,
                                        defaultValue: "Group Code:",
                                    }
                                )}
                                tooltip={t(
                                    "Page.Operation.Clustering.Tooltips.Table",
                                    {
                                        lngs: i18n.languages,
                                        defaultValue: "",
                                    }
                                )}
                                style={{width: "30%"}}
                            >
                                <Select
                                    placeholder={t("Page.Operation.Clustering.Select.GroupCode", {
                                        lngs: i18n.languages,
                                        defaultValue: "Please select Group Code or leave empty for logic to apply to all",
                                    })}
                                    allowClear
                                    showSearch={true}
                                    showArrow={true}
                                    options={groupCodes.map((x: any) => ({
                                        label: x.code,
                                        value: x.code,
                                    }))}
                                    value={selectedProcessClusteringGroupCode}
                                    filterOption={(input, option) =>
                                        (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.value! < optionB.value! ? -1 : 1
                                    }
                                    onChange={handleGroupCodeChange}
                                ></Select>
                            </Form.Item>
                        </div>

                    </div>
                </Form>
            </Drawer>
            <TableDrawer
                title={t(
                    "Page.Operation.Clustering.Drawers.Results",
                    {
                        lngs: i18n.languages,
                        defaultValue: "Latest Clustering Results for {{groupCode}}",
                        groupCode: selectedGroupCode
                    }
                )}
                openDrawer={openResultsDrawer}
                columns={resultsColumns}
                tableData={resultsTableData}
                setTableData={setResultsTableData}
                isTableDataLoading={isResultsTableDataLoading}
                tablePageIndex={resultsTablePageIndex}
                setTablePageIndex={setResultsTablePageIndex}
                tablePageSize={resultsTablePageSize}
                setTablePageSize={setResultsTablePageSize}
                onExport={() => setShowExportDrawer(true)}
                onClose={() => setOpenResultsDrawer(false)}
            />
            <TableExport
                openDrawer={showExportDrawer}
                groupCodes={groupCodes}
                downloadTableData={downloadClusteringTableData}
                isDownloading={isDownloadingExportData}
                onClose={() => setShowExportDrawer(false)}
            />

            <Modal
                title={t("Page.Operation.Clustering.Labels.ProceedToBatchProcessing.Title", {
                    lngs: i18n.languages,
                    defaultValue: "Proceed to Batch Processing?",
                })}
                okText={t("Page.Operation.Clustering.Labels.ProceedToBatchProcessing.SeeTheQueue", {
                    lngs: i18n.languages,
                    defaultValue: "See the queue",
                })}
                cancelText={t("Page.Operation.Clustering.Labels.ProceedToBatchProcessing.Stay", {
                    lngs: i18n.languages,
                    defaultValue: "Stay on Clustering screen",
                })}
                visible={isRedirectModalOpen}
                onOk={handleRedirectModalOk}
                onCancel={handleRedirectModalCancel}>
                <p>{t("Page.Operation.Clustering.Labels.ProceedToBatchProcessing.ContentPartOne", {
                    lngs: i18n.languages,
                    defaultValue: "Your clustering process has been added to the batch processing queue for",
                })} {t("Page.Operation.Clustering.Labels.ProceedToBatchProcessing.ContentPartImmediate", {
                    lngs: i18n.languages,
                    defaultValue: "immediate processing",
                })}
                    {t("Page.Operation.Clustering.Labels.ProceedToBatchProcessing.ContentPartScheduled", {
                        lngs: i18n.languages,
                        defaultValue: "processing at the scheduled time(s)",
                    })}. {t("Page.Operation.Clustering.Labels.ProceedToBatchProcessing.ContentPartTwo", {
                        lngs: i18n.languages,
                        defaultValue: "Do you want to see the queue or stay on current screen?",
                    })}
                </p>
            </Modal>
        </div>
    );
};

export default Clustering;
